export const DEFAULT_LIMITS_PARAMS_FORMATTER = function limitsParamsFormatter() {
  return {
    currency: 'RUB',
  };
};
